// Accessed key-by-key so Vite statically replaces each one at build time; aliasing
// import.meta.env to a local would inline the whole env object instead.
export const config = {
    clientId: import.meta.env.REACT_APP_CLIENTID,
    authority: import.meta.env.REACT_APP_AUTHORITY,
    redirectUri: import.meta.env.REACT_APP_REDIRECTURI,
    scope: import.meta.env.REACT_APP_SCOPE,

    ApplicationTitle: import.meta.env.REACT_APP_APPLICATION_TITLE,
    ApplicationShortName: import.meta.env.REACT_APP_APPLICATION_SHORT_NAME,
    ApplicationEnvironment: import.meta.env.REACT_APP_APPLICATION_ENVIRONMENT_NAME,
    Version: import.meta.env.REACT_APP_VERSION,

    baseUrl: import.meta.env.REACT_APP_BASEURL,
    timeout: Number.parseInt(import.meta.env.REACT_APP_TIMEOUT),
    retryCount: Number.parseInt(import.meta.env.REACT_APP_RETRY_COUNT),
    retryDelay: Number.parseInt(import.meta.env.REACT_APP_RETRY_DELAY)
}
